import React from 'react';

export const UsersTab = ({ recentUsers, recentAssessments }) => (
  <div data-testid="users-tab" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
    <div className="card">
      <h3 style={{ fontSize: '1rem', marginBottom: '1rem' }}>Recent Users</h3>
      {recentUsers.length === 0 ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem 0' }}>No users yet</p>
      ) : recentUsers.map((user) => (
        <div key={user.email || user.user_id} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.875rem', background: 'var(--bg-subtle)', borderRadius: 'var(--radius-md)', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
          <div>
            <div style={{ fontWeight: 600 }}>{user.full_name}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.8125rem' }}>{user.email}</div>
          </div>
          <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{user.created_at ? new Date(user.created_at).toLocaleDateString() : ''}</div>
        </div>
      ))}
    </div>
    <div className="card">
      <h3 style={{ fontSize: '1rem', marginBottom: '1rem' }}>Recent Assessments</h3>
      {recentAssessments.length === 0 ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem 0' }}>No assessments yet</p>
      ) : recentAssessments.map((a) => (
        <div key={a.assessment_id || a.created_at} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.875rem', background: 'var(--bg-subtle)', borderRadius: 'var(--radius-md)', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
          <div style={{ color: 'var(--text-muted)' }}>ID: {a.assessment_id?.substring(0, 8)}...</div>
          <span className={`badge ${a.status === 'paid' ? 'badge-success' : 'badge-warning'}`} style={{ fontSize: '0.6875rem' }}>
            {a.status}
          </span>
        </div>
      ))}
    </div>
  </div>
);
